/**
 * @generated SignedSource<<d842931f82c57ff13f5397b235124e9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type discountCodeTable_DiscountCodeFragment$data = {
  readonly code: string;
  readonly createdAt: string;
  readonly createdBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly id: string;
  readonly numUsages: number;
  readonly updatedAt: string | null;
  readonly updatedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeDeleteButton_DiscountCodeFragment" | "discountCodeEditButton_DiscountCodeFragment">;
  readonly " $fragmentType": "discountCodeTable_DiscountCodeFragment";
};
export type discountCodeTable_DiscountCodeFragment$key = {
  readonly " $data"?: discountCodeTable_DiscountCodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeTable_DiscountCodeFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "discountCodeTable_DiscountCodeFragment"
};

(node as any).hash = "f79844c759d65c2ad9c898e5760fbd58";

export default node;
